export enum SDPDivisionEnum {
  ELECTRICITY = 'ELECTRICITY',
  GAS = 'GAS',
}

export namespace SDPDivisionEnum {
  export const getUnit = (value?: SDPDivisionEnum) => {
    switch (value) {
      case SDPDivisionEnum.ELECTRICITY:
        return 'kWh';
      case SDPDivisionEnum.GAS:
        return 'm³';
      default:
        return 'kWh';
    }
  };
  export const getTranslation = (value?: SDPDivisionEnum) => {
    switch (value) {
      case SDPDivisionEnum.ELECTRICITY:
        return 'common.electricity';
      case SDPDivisionEnum.GAS:
        return 'common.gaz';
      default:
        return '';
    }
  };
}
